export default String.raw`
<div class="message-popup-background">
    <div class="change-data-container">
        <div class="data-form">
            <div class="data-form__header">
                {{ translations.ChangePassword }}
                <button class="close-button replace-template-js close-js" data-template="partials/customer-profile/your-account/employee-data.html" data-container=".employee-data-js" aria-label="{{ translations.Close }}">
                    <svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
                </button>
            </div>
			<div class="form-js password-form-js">
				<div class="form__input-wrapper">
					<label for="changeOldPassword" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.OldPassword }}</label>
					<input id="changeOldPassword" class='form__input-value input-value-js onlyInputEventValidation' type="password" name="oldPassword" value="" title="{{translations.ShowPassword}}" maxlength="50" required autocomplete="current-password" >
					<div tabindex="0" role="button" aria-label="{{ translations.HideShowPassword }}" class="form__icons form__preview form__preview-js">	
						<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#eye-{{settings.iconStyle}}"></use></svg>
					</div>
				<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillOldPassword }}</div>
				</div>
				<div class="form__input-wrapper">
					<label for="changeCurrentPassword" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.NewPassword }}</label>
					<input id="changeCurrentPassword" class='form__input-value input-value-js onlyInputEventValidation' type="password" name="password" value="" title="{{translations.ShowPassword}}" maxlength="50" required autocomplete="new-password">
					<div tabindex="0" role="button" aria-label="{{ translations.HideShowPassword }}" class="form__icons form__preview form__preview-js">
						<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#eye-{{settings.iconStyle}}"></use></svg>
					</div>
					<div class="validation-info__container validation-info-js password-valid-js hidden-js">
						{{ translations.PasswordMustHave }}
						<div class="validation-info__element min-8-char-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.Min8Char }}</span>
						</div>
						<div class="validation-info__element big-letter-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.BigLetter }}</span>
						</div>
						<div class="validation-info__element small-letter-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.SmallLetter }}</span>
						</div>
						<div class="validation-info__element digit-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.Digit }}</span>
						</div>
						<div class="validation-info__element special-char-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.SpecialChar }}</span>
						</div>
					</div>
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillNewPassword }}</div>
				</div>
				<div class='form__input-wrapper'>
					<label for="changePasswordRepeat" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.RepeatNewPassword }}</label> 
					<input id="changePasswordRepeat" class="form__input-value input-value-js onlyInputEventValidation" type="password" name="passwordRepeat" value="" title="{{translations.ShowPassword}}" maxlength="50" required autocomplete="new-password" >     
					<div tabindex="0" role="button" aria-label="{{ translations.HideShowPassword }}" class="form__icons form__preview form__preview-js">
						<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#eye-{{settings.iconStyle}}"></use></svg>
					</div>
					<div class="form__invalid-input validation-info-js validation-info-password-repeat-js hidden-js">{{ translations.PasswordMismatch }}</div>
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
				</div> 
				<div class="required-fields"><span class='required'>* </span>{{ translations.RequiredFields }}</div>
				<input type="hidden" name="__action" value="Customer/OldPasswordChange">
				<button class="primary-action-button change-password-trigger-js closing-modal-mobile-js" data-template="partials/customer-profile/your-account/employee-data.html" data-container=".employee-data-js">
					{{ translations.ChangePassword }}
				</button>
			</div>
        </div>
    </div>
</div>

{% include 'partials/customer-profile/your-account/employee-data.html' -%}
`